/**
 * Constants class for common parameters in the appointment application
 */
export enum McsisConstants {
  ParticipantDetailsUrl = '/Pages/Search/PageLoader.aspx?entity_type=1&entity_id=',
  SwissDateFormat = 'DD.MM.YYYY',
  DefaultDateFormat = 'YYYY-MM-DD',
  DefaultYearFormat = 'YYYY',
  DefaultTimeZone = 'Europe/Zurich',
  EmptyString = '',
  SwissCountryCode = 'ch',
  LanguageFrCode = 'fr',
  LanguageDeCode = 'de',
  CommaSeparator = ',',
  SlotTimeFormat = 'HH:mm',
  SubstractDaysParameter = 'days',
  InternationalPhoneNumberRegex = '(^[+]\\b41\\b)\\s([0-9]{2})\\s([0-9]{3})\\s([0-9]{2})\\s([0-9]{2}$)',
  PhoneNumberRegex = '^0[0-9]{2}\\s[0-9]{3}\\s[0-9]{2}\\s[0-9]{2}$',
  EmailRegex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
}
